// shared-lib/labor/signatureCounts.js
//
// Quantities kept per work item and qualifier signature —
// `{ [workItemId]: { [signature]: quantity } }`, `''` for the base — the shape
// the take-off hands the labor its electrical devices (`devices.js`) and a
// stone top's fabrication (`estimate/countertopFabrication.js`) in: counted
// per room, summed over the rooms an estimate covers. Pure.

/** `more` added into `into` (mutated and returned): the take-off summary's sum. */
function addSignatureCounts(into, more) {
  for (const [workItemId, bySig] of Object.entries(more || {})) {
    into[workItemId] = into[workItemId] || {};
    for (const [sig, n] of Object.entries(bySig)) {
      into[workItemId][sig] = (into[workItemId][sig] || 0) + n;
    }
  }
  return into;
}

/**
 * The same quantities kept by the take-off ROWS they are labor for (labor
 * kept per item, claude-docs/2026-10-16-estimate-labor-by-item-design.md):
 * `{ [rowsKey]: { [workItemId]: { [signature]: quantity } } }`. A rows key is
 * the rows' keys, each once, sorted and joined by a newline — `''` for work
 * on no row. Work done on two rows at once (a seam joining two stones) names
 * both.
 */
const rowsKey = (rowKeys) =>
  [...new Set((rowKeys || []).filter(Boolean))].sort().join('\n');
const rowKeysOf = (key) => (key ? key.split('\n') : []);

/** `more` added into `into` (mutated and returned), row by row. */
function addSignatureCountsByRow(into, more) {
  for (const [key, counts] of Object.entries(more || {})) {
    into[key] = addSignatureCounts(into[key] || {}, counts);
  }
  return into;
}

/** Quantities kept by row, as the job's totals. */
const totalSignatureCounts = (byRow) => {
  const out = {};
  for (const counts of Object.values(byRow || {}))
    addSignatureCounts(out, counts);
  return out;
};

module.exports = {
  addSignatureCounts,
  addSignatureCountsByRow,
  totalSignatureCounts,
  rowsKey,
  rowKeysOf,
};
